import { render, staticRenderFns } from "./ExpedientAgendaComponent.vue?vue&type=template&id=1e50f7d2&scoped=true&lang=pug"
import script from "./ExpedientAgendaComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientAgendaComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientAgendaComponent.vue?vue&type=style&index=0&id=1e50f7d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50f7d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e50f7d2')) {
      api.createRecord('1e50f7d2', component.options)
    } else {
      api.reload('1e50f7d2', component.options)
    }
    module.hot.accept("./ExpedientAgendaComponent.vue?vue&type=template&id=1e50f7d2&scoped=true&lang=pug", function () {
      api.rerender('1e50f7d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientAgenda/ExpedientAgendaComponent.vue"
export default component.exports